export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.719 11a2 2 0 011.94 2.485l-1.068 4.272a1 1 0 00.97 1.243h1.94v2H2.78a2 2 0 01-1.94-2.485l1.5-6A2 2 0 014.281 11h9.438zm-9.242 2a.25.25 0 00-.243.19l-1.375 5.5a.25.25 0 00.243.31h8.923a.25.25 0 00.242-.19l1.374-5.5A.25.25 0 0013.4 13H4.477z\" fill=\"#7B61FF\"/><path d=\"M19.73 3a2.5 2.5 0 012.466 2.089l1.5 9A2.5 2.5 0 0121.231 17H17.5v-2h3.73a.5.5 0 00.493-.582l-1.5-9A.5.5 0 0019.73 5H4.794c-.31 0-.55.282-.495.593.118.677.25 1.438.35 2.056.051.309.095.586.127.802A4.6 4.6 0 014.834 9h-2c0 .038-.002-.017-.037-.259-.03-.199-.071-.463-.121-.767-.1-.608-.23-1.36-.348-2.037A2.505 2.505 0 014.794 3h14.937z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};